import { IStaffResItem } from 'services/types/response';
import { IStaffUI } from 'types/staff';

/**
 * Maintenance staff are hourly, non-service workers (cleaner, maintainer). They
 * never take a booking or an appointment, so every staff picker drops them.
 *
 * Deliberately NOT applied to the Turn module: on this app the turn board is
 * also the clock in/out screen, and Maintenance staff must clock in there for
 * their worked hours — and therefore their pay — to be recorded. It is also not
 * applied to name/avatar lookups (`staffs.find(...)`), which would otherwise
 * render an existing appointment's staff as "Anyone".
 *
 * Accepts both shapes in use: the raw API item and the UI item that keeps the
 * raw one under `extraData`. Compared lowercased because positionName is stored
 * with inconsistent casing depending on which client created the staff record.
 */
export const isBookableStaff = (
  staff?: Partial<IStaffResItem> | IStaffUI | null,
): boolean => {
  const position =
    (staff as Partial<IStaffResItem>)?.positionName ??
    (staff as IStaffUI)?.extraData?.positionName;
  return `${position ?? ''}`.toLowerCase() !== 'maintenance';
};

/**
 * False when the day view marks this staff as not working the viewed day
 * (`timeSchedule.enable === false`). The backend still lists such a staff when
 * they have booked appointments that day, so their column can show them; the
 * booking pickers must not offer the staff for a new appointment though.
 * A missing `timeSchedule` means no schedule row, which counts as working.
 */
export const isStaffWorkingToday = (staff?: IStaffUI | null): boolean =>
  staff?.timeSchedule?.enable !== false;

/**
 * Trang calendar ma staff nay thuoc ve.
 *
 * FULL_SCREEN xep 15 nguoi mot trang, che do thuong 12 — hai con so nay duoc gan san vao
 * `pageZoom` / `page` luc map staff. Moi noi phan trang phai doc qua day, neu khong nut mui ten
 * se chan bien theo mot he quy chieu con header lai loc theo he quy chieu khac.
 */
export const getStaffCalendarPage = (
  staff: IStaffUI | undefined | null,
  fullScreen: boolean,
): number | undefined => (fullScreen ? staff?.pageZoom : staff?.page);
